export default {
	state: {
		user: {
			connected: false,
			id: null,
			name: null,
			preferences: {
				autofill: true,
				darkMode: true,
				reverseOrder: false,
			},
		},
		ui: {
			popup: {
				show: false,
				title: "An error occured",
				description: "Couldn't connect to server",
			},
		},
		errors: [],
		currentError: null,
		dev: {
			isDev: false,
			preferences: {
				mockingServer: true,
				mockingLocal: true,
				devPlayer: true,
			},
			localMock: {
				roomCode: null,
				socketId: null,
			},
		},
	},
	getters: {
		// Server
		connected: state => state.user.connected,
		local: () => {
			return {
				socketId: localStorage.getItem("socketId"),
				roomCode: localStorage.getItem("roomCode"),
			};
		},
		localMock: state => {
			return {
				socketId: state.dev.localMock.socketId,
				roomCode: state.dev.localMock.roomCode,
			};
		},
		// User preferences
		username: state => state.user.name,
		userId: state => state.user.id,
		userPreferences: state => state.user.preferences,
		autofill: state => state.user.preferences.autofill,
		reverseOrder: state => state.user.preferences.reverseOrder,
		darkMode: state => state.user.preferences.darkMode,
		isDev: state => state.dev.isDev,
		devPreferences: state => state.dev.preferences,
		mockingServer: state =>
			state.dev.isDev && state.dev.preferences.mockingServer,
		mockingLocal: state =>
			state.dev.isDev && state.dev.preferences.mockingLocal,
		forceDevPlay: state =>
			state.dev.isDev && state.dev.preferences.devPlayer,
		// UI
		showPopup: state => state.ui.popup.show,
		popup: state => state.ui.popup,
		errors: state => state.errors,
		currentError: state => state.currentError,
		// Development stuff
		devPlayMock: () => {
			return {
				addPoint: "PLAY_ADD_POINT",
				passTurn: "PLAY_PASS_TURN",
				dealCards: "DEV_DEAL_CARDS",
				inProgress: "DEV_TOGGLE_INPROGRESS",
				win: "PLAY_ANNOUNCE_WINNER",
			};
		},
	},
	actions: {
		userToggleOption({ commit }, anOption) {
			commit("USER_TOGGLE_PREFERENCE", anOption);
		},
		devToggleOption({ commit }, anOption) {
			commit("DEV_TOGGLE_PREFERENCE", anOption);
		},
		userSetName({ commit }, aName) {
			commit("USER_SET_NAME", aName);
		},
		addError({ commit }, anError) {
			commit("ADD_LOG_MESSAGE", anError);
		},
		removeError({ commit }, anIndex) {
			commit("REMOVE_LOG_MESSAGE", anIndex);
		},

		setLocalStorageId({ commit, getters }, aSocketId) {
			getters.mockingLocal
				? commit("SET_MOCK_LOCAL_STORAGE_ID", aSocketId)
				: localStorage.setItem("socketId", aSocketId);
		},
		setLocalStorageRoomCode({ commit, getters }, aRoomCode) {
			getters.mockingLocal
				? commit("SET_MOCK_LOCAL_STORAGE_ROOM_CODE", aRoomCode)
				: localStorage.setItem("roomCode", aRoomCode);
		},

		clearLocalData({ commit, getters }) {
			getters.mockingLocal
				? commit("CLEAR_MOCK_LOCAL_STORAGE")
				: localStorage.clear();
		},

		showPopupError({ commit }, anError) {
			commit("SHOW_POP_UP_ERROR", anError);
		},
		hidePopupError({ commit }) {
			commit("HIDE_POP_UP_ERROR");
		},
	},
	mutations: {
		// User state
		USER_SET_CONNECTED: state => {
			state.user.connected = true;
		},
		USER_SET_DISCONNECTED: state => {
			state.user.connected = false;
		},
		USER_SET_ID: (state, aSocketId) => {
			state.user.id = aSocketId;
			// console.log("My socket connection:", state.user.id);
		},
		USER_SET_NAME: (state, aName) => {
			state.user.name = aName;
		},
		USER_TOGGLE_PREFERENCE: (state, anOption) => {
			state.user.preferences[anOption] = !state.user.preferences[
				anOption
			];
		},
		DEV_TOGGLE_PREFERENCE: (state, anOption) => {
			state.dev.preferences[anOption] = !state.dev.preferences[anOption];
		},
		SET_LOCAL_STORAGE_ID: (state, aSocketId) => {
			localStorage.setItem("socketId", aSocketId);
		},
		SET_LOCAL_STORAGE_ROOM_CODE: (state, aRoomCode) => {
			localStorage.setItem("roomCode", aRoomCode);
		},
		SET_MOCK_LOCAL_STORAGE_ID: (state, aSocketId) => {
			state.dev.localMock.socketId = aSocketId;
		},
		SET_MOCK_LOCAL_STORAGE_ROOM_CODE: (state, aRoomCode) => {
			state.dev.localMock.roomCode = aRoomCode;
		},
		CLEAR_MOCK_LOCAL_STORAGE: state => {
			state.dev.localMock.socketId = null;
			state.dev.localMock.roomCode = null;
		},

		ADD_LOG_MESSAGE: (state, anError) => {
			let i = state.errors.length;
			state.errors.push(anError);
			setTimeout(() => {
				state.errors.splice(i, 1);
			}, 2000);
		},
		REMOVE_LOG_MESSAGE: (state, anIndex) => {
			state.errors.splice(anIndex, 1);
		},
		SHOW_POP_UP_ERROR: (state, anError) => {
			state.ui.popup.show = true;
			state.ui.popup.description = anError;
		},
		HIDE_POP_UP_ERROR: state => {
			state.ui.popup.show = false;
		},
	},
};
